import { actionCreatorFactory } from "typescript-fsa";
import { FacebookUser } from "core/types/facebook-user.types";

const actionCreator = actionCreatorFactory("facebook_user");

export const resetFacebookUser = actionCreator<void>("RESET");
export const facebookUser = actionCreator<{ facebookUser: FacebookUser }>(
  "FACEBOOK_USER_SUCCESS"
);
export const isFacebookUserLoading = actionCreator<{
  isFacebookUserLoading: boolean;
}>("IS_FACEBOOK_USER_LOADING");
